module.exports = __webpack_public_path__ + "static/img/dd02.d4db1ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dd02.png
// module id = /Zzp
// module chunks = 0